import { Component, inject } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { STORAGE_KEY_LOCALE } from './core/constants/Constants';
import { CacheImplService } from './shared/services/cache/cache-impl.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  readonly translate = inject(TranslateService);
  readonly cacheService = inject(CacheImplService);


  constructor() {
    const translate = this.translate;
    const cacheService = this.cacheService;

    if (cacheService.getItem(STORAGE_KEY_LOCALE) === ""){
      cacheService.setItem(STORAGE_KEY_LOCALE, "es-ES");
    }
    translate.setDefaultLang('es-ES');
    translate.setDefaultLang(cacheService.getItem(STORAGE_KEY_LOCALE) as string ?? 'es-ES');
  }


}
